<div class="min-h-screen px-5 pb-32 pt-6">
  @if (check?.[checkKeys.Id]) {
    @if ((check?.[checkKeys.OutstandingAmount] ?? 0) <= 0) {
      <div class="flex items-center justify-center pb-3 md:w-8/12">
        <span><i class="icon icon-n-check text-3xl text-success-600 md:text-4xl"></i></span>
        <p
          class="text-accent ml-3 text-2xl font-bold leading-8 text-neutral-800 md:ml-4 md:text-5xl"
        >
          {{ 'pay-at-table.overview.bill-payed' | translate }}
        </p>
      </div>
      <div class="pb-3 md:w-8/12">
        <div class="mb-3 flex flex-col rounded-m bg-neutral-100 p-5 text-center md:mb-8 md:p-6">
          <p class="font-accent text-md font-bold text-neutral-800 md:text-29px">
            {{ 'pay-at-table.overview.thanks-for-visit' | translate }}
          </p>
        </div>
      </div>
    }
  }
  @if ((check?.[checkKeys.OutstandingAmount] ?? 0) > 0) {
    <h1 class="mb-1 font-accent text-2xl font-bold text-neutral-800 lg:text-3xl">
      {{ 'pay-at-table.overview.title' | translate }}
    </h1>
  }
  @if (check?.[checkKeys.Shop]; as shop) {
    @if (shop?.name) {
      <p class="mb-6 font-base text-sm text-neutral-600">
        <span> {{ shop.name }}</span>
        @if (check?.[checkKeys.OnSiteLocation]; as onsite) {
          <span> — {{ onsite.name }}</span>
        }
      </p>
    } @else {
      <p class="mb-3 h-6 w-9/12 animate-pulse rounded bg-neutral-200"></p>
    }
  }

  @if (check?.[checkKeys.Items]; as items) {
    @if (items?.length) {
      @for (item of items; track item.id) {
        <div
          class="flex items-start border-b border-neutral-300 py-3"
          [class.cursor-pointer]="shouldShowItemDescription(item)"
          (click)="onItemRowClick(item)"
        >
          <div class="mr-2 shrink-0">
            <app-quantity-atom [quantity]="1"></app-quantity-atom>
          </div>
          <div class="flex min-w-0 flex-1 items-start justify-between gap-2">
            <div class="min-w-0">
              <p class="m-0">
                <span class="inline-block font-base text-base font-bold leading-6 lg:text-md">{{
                  item.name
                }}</span>
              </p>
              @if (shouldShowItemDescription(item)) {
                <p
                  class="mt-0.5 font-base text-sm text-neutral-600"
                  [class.truncate]="!isItemDescriptionExpanded(item.id)"
                  [class.leading-5]="!isItemDescriptionExpanded(item.id)"
                  [class.whitespace-normal]="isItemDescriptionExpanded(item.id)"
                  [class.break-words]="isItemDescriptionExpanded(item.id)"
                >
                  {{ item.description }}
                </p>
              }
            </div>
            <span class="shrink-0">
              <app-price-atom
                [amount]="item.price"
                [format]="true"
                [bold]="false"
              ></app-price-atom>
            </span>
          </div>
        </div>
      }
    } @else {
      @for (i of [].constructor(5); track $index) {
        <div class="flex w-full items-center justify-between border-b border-neutral-300 py-3">
          <div class="flex w-9/12">
            <p class="h-6 w-6 animate-pulse rounded-2xl bg-neutral-400"></p>
            <p class="ml-2 h-6 w-7/12 animate-pulse bg-neutral-200"></p>
          </div>
          <div class="h-6 w-10 animate-pulse bg-neutral-200"></div>
        </div>
      }
    }
  }
  <ng-container>
    @if (check?.[checkKeys.Id]) {
      <div class="flex justify-between pb-5 pt-3">
        <span class="font-accent text-md font-bold leading-6">{{
          'pay-at-table.overview.total' | translate
        }}</span>
        <span class="font-accent text-base font-bold leading-6"
          ><app-price-atom [amount]="check[checkKeys.FinalPrice] / 100"></app-price-atom
        ></span>
      </div>
    } @else {
      <div class="mt-3 flex justify-between">
        <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-400"></p>
        <p class="mb-3 h-5 w-2/12 animate-pulse rounded bg-neutral-400"></p>
      </div>
    }
  </ng-container>

  @if (capturedTransactons; as transactions) {
    @for (transaction of transactions; track transaction) {
      <div class="border-b border-neutral-300 py-2 font-accent leading-6">
        <div class="flex justify-between">
          <p class="font-bold">
            {{ 'pay-at-table.overview.payment' | translate }}
          </p>
          <p class="pl-2">
            -
            @if (!transaction?.tip?.amount) {
              <app-price-atom
                [format]="true"
                [amount]="transaction.paid_amount"
                [bold]="false"
              ></app-price-atom>
            }
            @if (transaction?.tip?.amount) {
              <app-price-atom
                [format]="true"
                [amount]="transaction.paid_amount - transaction?.tip?.amount"
                [bold]="false"
              ></app-price-atom>
            }
          </p>
        </div>
        @if (transaction?.tip) {
          <div class="flex justify-between text-neutral-600">
            <p class="flex">
              <i class="icon icon-satisfied mr-1.5 flex items-center"></i
              >{{ 'pay-at-table.overview.tip' | translate }}
            </p>
            <p class="pl-2">
              <app-price-atom
                [format]="true"
                [amount]="transaction?.tip?.amount"
                [bold]="false"
              ></app-price-atom>
            </p>
          </div>
        }
      </div>
    }
  }

  <ng-container>
    @if (check?.[checkKeys.Id]) {
      <div class="flex justify-between py-3">
        <span class="font-accent text-md font-bold leading-6">{{
          'pay-at-table.overview.left-to-pay' | translate
        }}</span>
        <span class="font-accent text-base font-bold leading-6"
          ><app-price-atom [amount]="check[checkKeys.OutstandingAmount] / 100"></app-price-atom
        ></span>
      </div>
    } @else {
      <div class="flex justify-between">
        <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-400"></p>
        <p class="mb-3 h-5 w-2/12 animate-pulse rounded bg-neutral-400"></p>
      </div>
    }
  </ng-container>
</div>
